import React, {useState, useEffect} from 'react';
import {NavLink} from 'react-router-dom';
import {deleteActivity} from '../../../api/internal/activities.js';
import {getMonthShortName} from '../../../Helpers.js';
import './UserActivitiesLog.css';

const UserActivitiesLogItem = (props) => {
  const optionsRef = React.createRef();
  const [active, setActive] = useState(false);

  const handleClickOutside = (e) => {
    if (optionsRef.current && !optionsRef.current.contains(e.target) ) {
      setActive(false);
    }
  }
  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
        document.removeEventListener('click', handleClickOutside);
    };
  });

  const setCategoryName = (category) => {
    if(props.categories.length){
      let discipline = props.categories.find(i => i.name === category);
      return (discipline.displayName);
    }
  }
  const setIcon = (category) => {
    if(props.categories.length){
      let discipline = props.categories.find(i => i.name === category);
      return (discipline.icon);
    }
  }
  const getActivityType = (category, returnType = 'name') => {
    if(props.categories.length){
      let discipline = props.categories.find(i => i.name === category);
      if(discipline.type === 1){
        if(returnType === 'name'){
          return "Duration";
        } else {
          return 1;
        }
      } else if (discipline.type === 2){
        if(returnType === 'name'){
          return "Distance";
        } else {
          return 2;
        }
      }
    }
  }
  const showTimeInHoursAndMinutes = (timeInMinutes) =>{
    const hours = Math.floor(timeInMinutes / 60 );
    const minutes = Math.floor(timeInMinutes) % 60;
    return (hours === 0 ? `${minutes} min` : `${hours} h ${minutes} min`);
  }

  const deleteThisActivity = (userId, activityId) => {
    deleteActivity(userId, activityId)
      .then(
        (result) => {
          if(result.status === 200){
            props.updateProfile();
          }
        },
        (error) => {
          console.log('deleteThisActivity() ERROR: ', error);
        }
      );
  }

  return (
    <li className="UserActivitiesLog-item">
      <div className="UserActivitiesLog-itemDate">
        <span className="UserActivitiesLog-itemLabel">{getMonthShortName(new Date(props.userActivity.startDate).getMonth())}</span>
        <span className="UserActivitiesLog-itemValue">{new Date(props.userActivity.startDate).getDate()}</span>
      </div>
      <div className="UserActivitiesLog-itemDiscipline">
        <img src={setIcon(props.userActivity.discipline)} alt={props.userActivity.discipline} className="UserActivitiesLog-itemDiscipline-icon" />
        <span className="UserActivitiesLog-itemDiscipline-name">{setCategoryName(props.userActivity.discipline)}</span>
      </div>
      <div className={`UserActivitiesLog-itemCalories ${(props.userActivity.calculatedCalories ? 'empty': '')}` }>
        {!props.userActivity.calculatedCalories &&
          <React.Fragment>
            <span className="UserActivitiesLog-itemLabel">Calories</span>
            <span className="UserActivitiesLog-itemValue">{props.userActivity.calories} kcal</span>
          </React.Fragment>
        }
      </div>
      <div className="UserActivitiesLog-itemActivity">
        <span className="UserActivitiesLog-itemLabel">{getActivityType(props.userActivity.discipline)}</span>
        <span className="UserActivitiesLog-itemValue">{(getActivityType(props.userActivity.discipline) === 'Distance' ? (props.userActivity.distanceInMeters / 1000).toFixed(1)+'km' : showTimeInHoursAndMinutes(props.userActivity.durationInMinutes) )}</span>
      </div>
      <div className="UserActivitiesLog-itemPoints">
        <span className="UserActivitiesLog-itemLabel">Points</span>
        <span className="UserActivitiesLog-itemValue">{props.userActivity.points.toFixed(1)} pts</span>
      </div>
      <div className="UserActivitiesLog-itemOptions" onClick={() => (setActive(prev => !prev)) } ref={optionsRef}>
        <ul className={`UserActivitiesLog-itemOptions__list ${active ? 'active' : ''}`}>
          <li className="UserActivitiesLog-itemOptions__listItem">
            <NavLink className="UserActivitiesLog-itemOptions__listItem--edit"
              to={{
                pathname: `/dashboard/edit-activity`,
                startDate: props.userActivity.startDate,
                discipline: props.userActivity.discipline,
                disciplineName: setCategoryName(props.userActivity.discipline),
                type: getActivityType(props.userActivity.discipline, 'typeCode'),
                distanceInKiloMeteres: (props.userActivity.distanceInMeters / 1000),
                movingTimeInHours: Math.floor(props.userActivity.durationInMinutes / 60),
                movingTimeInMinutes: Math.floor(props.userActivity.durationInMinutes % 60),
                showCalories: !props.userActivity.calculatedCalories,
                calories: props.userActivity.calories,
                activityId: props.userActivity.id
              }} >Edit</NavLink>
          </li>
          <li className="UserActivitiesLog-itemOptions__listItem" onClick={() => deleteThisActivity(props.userActivity.athleteId, props.userActivity.id)}>Delete</li>
        </ul>
      </div>
    </li>
  );
}

const UserActivitiesLog = (props) => {
  console.log('UA log - props', props);
  return (
      <div className="UserActivitiesLog">
        <ul className="UserActivitiesLog-list">
          {props.userActivities.length === 0 &&
            <li className="UserActivitiesLog-item">
              <div className="UserActivitiesLog-itemEmpty">You haven&apos;t logged any activities yet.</div>
            </li>
          }
          {props.userActivities.length > 0 && props.userActivities.map( (i) => (
            <UserActivitiesLogItem key={i.id}
              userActivity={i}
              categories={props.categories}
              updateProfile={props.updateProfile}
            />
          ))
          }
        </ul>
      </div>
  );
}
export default UserActivitiesLog;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/UserActivitiesLog/UserActivitiesLog.js